import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description:
    "In this example we will optimize the acoustic environment of a common classroom. This room has a wooden floor, plasterboard walls and a concrete ceiling.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/03/25/principle/principle-1.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
